import React from 'react';

export default function(props){
    return <div><div id="search-button" onClick={(event)=>{event.currentTarget.nextElementSibling.classList.toggle("toggled"); event.currentTarget.nextElementSibling.firstElementChild.firstElementChild.focus();}}><i className="fa fa-search"></i></div> 

    <div id="search">
    <form role="search" method="get" id="searchform" className="searchform" action="http://www.ideasmulticolor.com/">
        <input type="text" defaultValue="" name="s" id="s"/>
        </form>
</div></div>}